import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';

const styles = {
  addToCalendarButtonTooltip: {
    padding: '15px 20px 30px 20px',
    position: 'absolute',
    top: '-162px',
    left: '45px',
    maxWidth: '330px',
    height: '222px',
    background: '#FFFFFF',
    boxShadow:
      '0px 2px 4px rgba(81, 92, 98, 0.08), 0px 0px 1px rgba(179, 183, 186, 0.8)',
    borderRadius: '4px',
    display: 'block',
    zIndex: '1',
  },
  calendarProviderLink: {
    display: 'block',
    textAlign: 'center',
    marginTop: '2%',
    height: '22px',
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: 'NiveauGroteskRegular',
    color: '#0076BB',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
      color: '#111',
    },
  },
  iconPlaceholder: {
    display: 'block',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    background: '#0076BB',
  },
};

const AddToCalendarButtonTooltip = ({ calendarEvent, callBack }) => {
  const MINUTE_IN_MS = 60 * 1000;
  const formatDateForCalendarUrl = date => {
    return date.toISOString().replace(/-|:|\.\d+/g, '');
  };
  const addMinutesToDate = (date, minutes) => {
    return new Date(date.getTime() + minutes * MINUTE_IN_MS);
  };
  const getEndTime = cl => {
    return cl.endDate ?? addMinutesToDate(cl.startDate, cl.durationInMinutes);
  };
  const generateGoogleCalendarUrl = cl => {
    const startDate = formatDateForCalendarUrl(cl.startDate);
    const endDate = formatDateForCalendarUrl(getEndTime(cl));
    const encodedUrl = encodeURI(
      [
        'https://www.google.com/calendar/render',
        '?action=TEMPLATE',
        `&text=${cl.title || ''}`,
        `&dates=${startDate || ''}`,
        `/${endDate || ''}`,
        // TODO: append video appointment link to description
        `&details=${`${cl.description}\n` || ''}`,
        `&location=${cl.address || ''}`,
        '&sprop=&sprop=name:',
      ].join(''),
    );
    return encodedUrl;
  };
  const generateIcsCalendarFile = cl => {
    const startDate = formatDateForCalendarUrl(cl.startDate);
    const endDate = formatDateForCalendarUrl(getEndTime(cl));
    const encodedUrl = encodeURI(
      `data:text/calendar;charset=utf8,${[
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        `URL:${document.URL}`,
        `DTSTART:${startDate || ''}`,
        `DTEND:${endDate || ''}`,
        `SUMMARY:${cl.title || ''}`,
        `DESCRIPTION:${cl.description || ''}`,
        `LOCATION:${cl.address || ''}`,
        'END:VEVENT',
        'END:VCALENDAR',
      ].join('\n')}`,
    );
    return encodedUrl;
  };
  const helpers = {
    formatTime(date) {
      return date.toISOString().replace(/-|:|\.\d+/g, '');
    },
    getEventDurationForYahoo(cl) {
      const eventDuration = cl.endDate
        ? (cl.endDate.getTime() - cl.startDate.getTime()) / MINUTE_IN_MS
        : cl.durationInMinutes || 0;
      const yahooHourDuration = eventDuration < 600
          ? `0${Math.floor(eventDuration / 60)}`
          : `${Math.floor(eventDuration / 60)}`;
      const yahooMinuteDuration = eventDuration % 60 < 10
          ? `0${eventDuration % 60}`
          : `${eventDuration % 60}`;
      const yahooEventDuration = yahooHourDuration + yahooMinuteDuration;
      return yahooEventDuration;
    },
  };
  const generateYahooCalendarUrl = cl => {
    const st = helpers.formatTime(cl.startDate);
    const duration = helpers.getEventDurationForYahoo(cl);
    const encodedUrl = encodeURI(
      [
        'http://calendar.yahoo.com/?v=60&view=d&type=20',
        `&title=${cl.title || ''}`,
        `&st=${st || ''}`,
        `&dur=${duration || ''}`,
        `&desc=${cl.description || ''}`,
        `&in_loc=${cl.address || ''}`,
      ].join(''),
    );
    return encodedUrl;
  };

  return (
    <div
      role='presentation'
      style={styles.addToCalendarButtonTooltip}
      onClick={() => callBack()}
    >
      <CloseIcon
        style={{
          width: '15px',
          height: '15px',
          color: '#0076BB',
          cursor: 'pointer',
          position: 'absolute',
        }}
      />
      <div
        style={{
          textAlign: 'center',
          fontFamily: 'NewOrderBold',
          fontWeight: '700',
          fontSize: '16px',
          lineHeight: '20px',
          color: '#0076BB',
          marginTop: '7%',
        }}
      >
        Add to your calendar!
      </div>
      <div
        style={{
          textAlign: 'left',
          fontFamily: 'NiveauGroteskRegular',
          fontWeight: '700',
          fontSize: '14px',
          lineHeight: '20px',
        }}
      >
        Add the <b>{calendarEvent.title}</b> to your preferred calendar below.
      </div>
      <a
        href={generateGoogleCalendarUrl(calendarEvent)}
        target='_blank'
        rel='noreferrer'
        style={styles.calendarProviderLink}
      >
        Google Calendar
      </a>
      <a
        href={generateIcsCalendarFile(calendarEvent)}
        target='_blank'
        rel='noreferrer'
        style={styles.calendarProviderLink}
      >
        Apple Calendar
      </a>
      <a
        href={generateYahooCalendarUrl(calendarEvent)}
        target='_blank'
        rel='noreferrer'
        style={styles.calendarProviderLink}
      >
        Yahoo Calendar
      </a>
      <a
        href={generateIcsCalendarFile(calendarEvent)}
        target='_blank'
        rel='noreferrer'
        style={styles.calendarProviderLink}
      >
        Outlook Calendar
      </a>
    </div>
  );
};

AddToCalendarButtonTooltip.propTypes = {
  calendarEvent: PropTypes.any.isRequired,
  callBack: PropTypes.any,
};
export default AddToCalendarButtonTooltip;
